import React from 'react';
import cuid from 'cuid';
import useIcon from '@empiriecom/module-components/utils/getIcon';
// eslint-disable-next-line no-shadow
export var TestIds;
(function (TestIds) {
    TestIds["content"] = "collapse__content";
    TestIds["header"] = "collapse__header";
})(TestIds || (TestIds = {}));
var Close = useIcon('Cancel');
var Collapse = function (_a) {
    var children = _a.children, headline = _a.headline, id = _a.id, propsIsOpen = _a.isOpen, _b = _a.uuid, uuid = _b === void 0 ? cuid() : _b;
    var isOpenFinal = headline === undefined || (propsIsOpen !== undefined ? propsIsOpen : false);
    return (React.createElement("div", { key: "collapse-tab-" + uuid, className: "tab" },
        React.createElement("input", { type: "radio", id: id, name: "rd", defaultChecked: isOpenFinal }),
        headline && (React.createElement("label", { key: "collapse-label-" + uuid, className: "tab-label", htmlFor: id, "data-testid": TestIds.header },
            headline,
            React.createElement("span", { key: "collapse-icon-" + uuid, className: "icon " + (isOpenFinal ? 'open' : 'close') },
                React.createElement(Close, { key: "collapse-icon-close-" + uuid, className: "icon-open" })))),
        React.createElement("div", { key: "collapse-tab-content-" + uuid, className: "tab-content " + (!headline && isOpenFinal ? 'no-header' : ''), "data-testid": TestIds.content }, children)));
};
export default Collapse;
//# sourceMappingURL=index.js.map